export default __webpack_public_path__ + "static/media/ill-pending.a0b8cdf6.svg";